import React from 'react';
import styled from 'styled-components';
import BedIconSvg from '../assets/hotels/details/bed.svg';

const BedIcon = styled(BedIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)(
  props => `
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.color};
  margin: ${props => props.margin};
  cursor: pointer;
`,
);

export default BedIcon;
